import { InvestorDetails } from '@/components/investors-page/investorDetailsPage';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const InvestorDetailsPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Investor Details</title>
      </Head>
      <InvestorDetails />
    </>
  );
};

export default InvestorDetailsPage;
